// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"ef26dbac","251":"fd6f074d","348":"82fd61d4","364":"aa2ff26c","571":"fe3345cf"}[chunkId] + ".chunk.js";
};